import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'

export function useSessionMonitor() {
  const session = useAuthStore(s => s.session)
  const signOut = useAuthStore(s => s.signOut)

  useEffect(() => {
    if (!session) return

    const interval = setInterval(() => {
      const expiresAt = session.expires_at
      if (!expiresAt) return

      const now = Math.floor(Date.now() / 1000)
      const timeLeft = expiresAt - now

      if (timeLeft < 300) {
        const shouldRenew = window.confirm('Sua sessão expirará em breve. Deseja renovar?')
        if (!shouldRenew) {
          signOut()
        }
      }
    }, 60000)

    return () => clearInterval(interval)
  }, [session, signOut])
}
